const stats = [
  { value: "12 år", label: "Erfarenhet av föreningsekonomi" },
  { value: "15 år", label: "Erfarenhet av regelefterlevnad" },
  { value: "24h", label: "Svarstid på frågor" },
];

export const About = () => {
  return (
    <section id="omoss" className="px-6 lg:px-8 py-24 lg:py-32 bg-paper">
      <div className="max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-7">
          <span className="text-xs font-medium tracking-widest uppercase text-oak mb-4 block">Om Adminlaget</span>
          <h2 className="font-display text-4xl md:text-5xl tracking-tight text-balance mb-8">
            Vi kan föreningslivet inifrån.
          </h2>
          <p className="text-lg text-ink-muted leading-relaxed text-pretty mb-5">
            Adminlaget kombinerar lång erfarenhet av bokföring och redovisning med ett genuint intresse för föreningsrörelsen.
            Vi har själva suttit i styrelser och haft kassörsrollen. Känslan av att bokföringen hopar sig veckan före årsmötet känner vi igen.
          </p>
          <p className="text-lg text-ink-muted leading-relaxed text-pretty mb-5">
            Därför har vi byggt en tjänst för verkligheten. För kassören utan ekonomibakgrund, för styrelsen som hellre lägger kvällen på verksamheten än på pappersarbete, och för föreningen som vill ha ordning på ekonomin utan att betala konsultpriser.
          </p>
          <p className="text-lg text-ink-muted leading-relaxed text-pretty">
            I dag hjälper vi föreningar över hela Sverige, från små idrottsklubbar på landsbygden till kulturföreningar i storstäderna. Kontoren finns i Strängnäs och norra Stockholm, men kunderna finns överallt.
          </p>

        </div>
        <div className="lg:col-span-5 grid grid-cols-1 gap-4">
          {stats.map((s) => (
            <div key={s.label} className="bg-surface rounded-2xl p-7 ring-1 ring-ink/5 flex items-baseline justify-between gap-4">
              <span className="font-display text-4xl md:text-5xl font-medium text-oak tabular-nums">{s.value}</span>
              <span className="text-sm text-ink-muted text-right max-w-[18ch]">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};